export const siteInfo = {
  name: '今日同人库',
  tagline: '每日精选同人作品聚合平台',
  description: '今日同人库是专为同人爱好者打造的每日精选内容聚合平台，汇集二次元同人小说、同人漫画、同人插画等优质作品，每日更新推荐，帮助创作者与读者高效发现热门同人内容。',
  url: 'https://jinritongrenku.com',
  logo: '今日同人库',
  founded: '2024',
  email: 'contact@jinritongrenku.com',
  address: '中国上海市浦东新区张江高科技园区',
  social: {
    weibo: 'https://weibo.com/jinritongrenku',
    bilibili: 'https://space.bilibili.com/jinritongrenku',
    lofter: 'https://jinritongrenku.lofter.com',
  },
};

export const aboutContent = {
  brandIntro: {
    title: '关于今日同人库',
    paragraphs: [
      '今日同人库成立于2024年，是国内领先的同人作品聚合与推荐平台。我们致力于为二次元同人爱好者打造一个高质量的内容发现社区，每日精选优质同人小说、同人漫画、同人插画、同人游戏、同人音乐及Cosplay作品，帮助创作者获得更多关注，帮助读者发现更多好作品。',
      '同人创作是二次元文化中最具活力的组成部分之一。它不仅是粉丝对原作热爱的表达，更是创作者们展示才华、交流创意的重要方式。今日同人库希望通过聚合推荐的方式，让更多优秀的同人作品被看到，让更多有才华的创作者被发现。',
      '我们的编辑团队由一群资深的二次元文化爱好者和专业内容编辑组成。每天，我们都会从海量的同人作品中筛选出最优秀的作品，以图文并茂的方式呈现给读者。我们关注的不仅是作品的热度，更是作品本身的质量和创意。',
    ],
  },
  mission: {
    title: '我们的使命',
    items: [
      { icon: 'ri-star-line', title: '发现好作品', desc: '每日精选推荐，帮你从海量内容中发现真正值得一看的同人佳作' },
      { icon: 'ri-heart-line', title: '支持创作者', desc: '为优秀的同人创作者提供展示平台，让才华被更多人看见' },
      { icon: 'ri-group-line', title: '连接同好', desc: '构建同人爱好者社区，让志同道合的人们在这里相遇交流' },
      { icon: 'ri-lightbulb-line', title: '激发创意', desc: '通过分享优秀作品激发更多人的创作灵感，繁荣同人文化' },
    ],
  },
  reputation: {
    title: '口碑与影响力',
    stats: [
      { value: '50万+', label: '月活跃用户' },
      { value: '3000+', label: '合作创作者' },
      { value: '10万+', label: '收录作品' },
      { value: '98%', label: '用户好评率' },
    ],
    testimonials: [
      {
        quote: '今日同人库是我每天必刷的网站。作为一个同人创作者，这里不仅让我的作品被更多人看到，也让我发现了很多优秀的同行。编辑的推荐质量真的很高！',
        author: '雨宫千夏',
        role: '人气同人画师',
        avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20of%20a%20happy%20female%20illustrator%20with%20paintbrush%2C%20warm%20and%20friendly%20expression%2C%20soft%20lighting%2C%20portrait%20illustration&width=100&height=100&seq=avatar-testimonial-01&orientation=squarish',
      },
      {
        quote: '从读者到创作者，今日同人库陪伴了我两年。这里的推荐算法真的很懂我，推给我的作品几乎都是我喜欢的类型。社区的讨论氛围也很好，大家都很有爱。',
        author: '星辰之笔',
        role: '同人小说作者',
        avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20of%20a%20smiling%20male%20writer%20with%20notebook%2C%20warm%20and%20approachable%20expression%2C%20cozy%20cafe%20background%2C%20portrait%20illustration&width=100&height=100&seq=avatar-testimonial-02&orientation=squarish',
      },
      {
        quote: '作为Cosplay爱好者，我最喜欢今日同人库的Cosplay专栏。每次都能看到很多高质量的Cos作品，也认识了很多志同道合的朋友。感谢这个平台！',
        author: '雪月花',
        role: '知名Coser',
        avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20of%20a%20confident%20female%20cosplayer%20with%20camera%2C%20vibrant%20and%20energetic%20expression%2C%20colorful%20background%2C%20portrait%20illustration&width=100&height=100&seq=avatar-testimonial-03&orientation=squarish',
      },
    ],
  },
  timeline: [
    { year: '2024年3月', event: '今日同人库正式上线，首批收录作品超过5000部' },
    { year: '2024年8月', event: '月活跃用户突破10万，新增同人游戏和同人音乐分类' },
    { year: '2025年1月', event: '举办首届"同人创作大赛"，收到投稿超过2000份' },
    { year: '2025年6月', event: '月活跃用户突破30万，推出创作者认证计划' },
    { year: '2025年12月', event: '与50+同人社团达成合作，启动"创作者扶持计划"' },
    { year: '2026年3月', event: '月活跃用户突破50万，成为国内最大同人作品聚合平台' },
  ],
};

export const faqData = [
  {
    question: '今日同人库是什么？',
    answer: '今日同人库是一个专注于二次元同人作品的每日精选聚合平台。我们每日从各类平台精选优质的同人小说、同人漫画、同人插画、同人游戏、同人音乐及Cosplay作品，为同人爱好者提供高质量的内容推荐服务。',
  },
  {
    question: '如何在今日同人库上推广我的作品？',
    answer: '你可以通过我们的"创作者认证计划"提交你的作品。我们的编辑团队会定期审阅投稿作品，优质作品将有机会登上每日推荐和首页展示。我们也会定期举办各类同人创作活动，欢迎关注。',
  },
  {
    question: '今日同人库的推荐标准是什么？',
    answer: '我们的编辑团队从作品质量、创意性、完成度和读者反馈等多个维度综合评估。我们注重作品本身的品质而非单纯的热度，致力于挖掘那些真正有才华的创作者和真正值得一看的好作品。',
  },
  {
    question: '今日同人库收费吗？',
    answer: '今日同人库对所有读者完全免费。我们致力于为同人爱好者提供最优质的内容发现体验。对于创作者，基础展示也是完全免费的。',
  },
  {
    question: '如何联系今日同人库团队？',
    answer: '你可以通过邮箱 contact@jinritongrenku.com 联系我们，或关注我们的微博、哔哩哔哩和Lofter账号了解更多最新动态。商务合作也欢迎通过邮箱联系。',
  },
];